import { render } from "./vp-inputcheckbox.vue?vue&type=template&id=6381f1dc"
import script from "./vp-inputcheckbox.vue?vue&type=script&lang=js"
export * from "./vp-inputcheckbox.vue?vue&type=script&lang=js"

import "./vp-inputcheckbox.vue?vue&type=style&index=0&id=6381f1dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__